
<template>
  <div class="reservationBox">
    <div class="form-cotain">
    <van-form label-width="100" ref="formRef">
      <van-field v-model="labName" label="实验教室名称" />
      <!-- <van-field v-model="applyUserId" label="校园卡号" required :rules="[{ required: true, message: '请填写校园卡号！' }]"/> -->
      <van-field
        readonly
        clickable
        name="picker"
        :value="project"
        label="预约用途"
        placeholder="点击选择预约用途"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          title="预约用途"
          :columns="projectList"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field v-model="groupNum" label="预约人数" type="digit" required :rules="[{ required: true, message: '请填写预约人数！' }, {validator: validatorNumber, message: '预约人数在1-100之间！'}]"/>
      <van-field v-model="phone" type="tel" label="手机号" required :rules="[{ required: true, message: '请填写手机号！' }, { validator: validatePhone, message: '手机号格式不正确！' }]"/>
    </van-form></div>
    <div class="schedule-table">
      <div class="nav-item">
        <button class="nav-button prev" @click="changeWeek('1')">-</button>
        <span class="nav-text">第{{weekObj.weekNum}}周</span>
        <button class="nav-button next" @click="changeWeek('2')">+</button>
      </div>
      <el-table
        :data="tableData"
        border
        :header-cell-style="{'text-align':'center','background-color':'#FAFCFE'}"
        :cell-style="columnStyle"
        @cell-click="columnClick"
        style="width: 100%">
        <el-table-column label="节次"  min-width="20%">
          <template slot-scope="scope">
            <div style="width: 100%;text-align: center;font-size:12px;">
              <p>{{scope.row.period.ptName}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周一" min-width="12%">
          <template slot-scope="scope">
            <div class="cell-number-style" v-if="scope.row.monday&&scope.row.monday[0]">
              <div class="cell-pic"></div>
              {{ getUserNumber(scope.row.monday) }}
            </div>
            <div class="overTimeBtn" v-if="isOverRoomTime(scope.row, '周一')">
              <div class="cell-pic"></div>
              <span></span>
            </div>
            <div style="width: 100%;text-align: center" v-if="scope.row.mondaycheck">
              <el-checkbox v-model="scope.row.mondaycheck" ></el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周二" min-width="12%">
          <template slot-scope="scope">
            <div class="cell-number-style" v-if="scope.row.tuesday&&scope.row.tuesday[0]">
              <div class="cell-pic"></div>
              {{ getUserNumber(scope.row.tuesday) }}
            </div>
            <div class="overTimeBtn" v-if="isOverRoomTime(scope.row, '周二')">
              <div class="cell-pic"></div>
              <span></span>
            </div>
            <div style="width: 100%;text-align: center" v-if="scope.row.tuesdaycheck">
              <el-checkbox v-model="scope.row.tuesdaycheck"></el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周三" min-width="12%">
          <template slot-scope="scope">
            <div class="cell-number-style" v-if="scope.row.wednesday&&scope.row.wednesday[0]">
              <div class="cell-pic"></div>
              {{ getUserNumber(scope.row.wednesday) }}
            </div>
            <div class="overTimeBtn" v-if="isOverRoomTime(scope.row, '周三')">
              <div class="cell-pic"></div>
              <span></span>
            </div>
            <div style="width: 100%;text-align: center" v-if="scope.row.wednesdaycheck">
              <el-checkbox v-model="scope.row.wednesdaycheck"></el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周四" min-width="12%">
          <template slot-scope="scope">
            <div class="cell-number-style" v-if="scope.row.thursday&&scope.row.thursday[0]">
              <div class="cell-pic"></div>
              {{ getUserNumber(scope.row.thursday) }}
            </div>
            <div class="overTimeBtn" v-if="isOverRoomTime(scope.row, '周四')">
              <div class="cell-pic"></div>
              <span></span>
            </div>
            <div style="width: 100%;text-align: center" v-if="scope.row.thursdaycheck">
              <el-checkbox v-model="scope.row.thursdaycheck"></el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周五" min-width="12%">
          <template slot-scope="scope">
            <div class="cell-number-style" v-if="scope.row.friday&&scope.row.friday[0]">
              <div class="cell-pic"></div>
              {{ getUserNumber(scope.row.friday) }}
            </div>
            <div class="overTimeBtn" v-if="isOverRoomTime(scope.row, '周五')">
              <div class="cell-pic"></div>
              <span></span>
            </div>
            <div style="width: 100%;text-align: center" v-if="scope.row.fridaycheck">
              <el-checkbox v-model="scope.row.fridaycheck"></el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周六" min-width="12%">
          <template slot-scope="scope">
            <div class="cell-number-style" v-if="scope.row.saturday&&scope.row.saturday[0]">
              <div class="cell-pic"></div>
              {{ getUserNumber(scope.row.saturday) }}
            </div>
            <div class="overTimeBtn" v-if="isOverRoomTime(scope.row, '周六')">
              <div class="cell-pic"></div>
              <span></span>
            </div>
            <div style="width: 100%;text-align: center" v-if="scope.row.saturdaycheck">
              <el-checkbox v-model="scope.row.saturdaycheck"></el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周日" min-width="12%">
          <template slot-scope="scope">
            <div class="cell-number-style" v-if="scope.row.sunday&&scope.row.sunday[0]">
              <div class="cell-pic"></div>
              {{ getUserNumber(scope.row.sunday) }}
            </div>
            <div class="overTimeBtn" v-if="isOverRoomTime(scope.row, '周日')">
              <div class="cell-pic"></div>
              <span></span>
            </div>
            <div style="width: 100%;text-align: center" v-if="scope.row.sundaycheck">
              <el-checkbox v-model="scope.row.sundaycheck"></el-checkbox>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="bottom_box">
      <el-button  round @click="submit">立即预约</el-button>
    </div>
  </div>
</template>
<script>
const weeksMap = {
  '周一': 1,
  '周二': 2,
  '周三': 3,
  '周四': 4,
  '周五': 5,
  '周六': 6,
  '周日': 0
}
export default {
  name: "reservation",
  data() {
    return{
      phone: '',
      timer: null,
      currentWeek: new Date().getDay(),
      currentWeekNum: 0,
      labName: '',
      applyUserId : '',
      groupNum: 1,
      weekObj:{},
      tableData:[],
      labId:'',
      labType:'',
      project:'',
      timeTableData:[],//预约时间列表
      showPicker:false,
      projectList:[],//开放项目列表
      weekDayList:[]
    }
  },
  computed: {
    isOverRoomTime(){
      return (row, columnName) => {
        return this.isOverDay(row, columnName)
      }
    }
  },
  methods:{
    validatePhone(value){
      const phoneRegex = /^1[3456789]\d{9}$/;
      if (!phoneRegex.test(value)) {
        return false
      }
      return true
    },
    validatorNumber(value){
      if(!Number(value) || Number(value) > 100) return false
      this.groupNum = Number(value)
    },
    getUserNumber(weekList){
      let number = 0;
      weekList.forEach(item=>{
        number += item.groupNum
      })
      return number ? number : ''
    },
    formatDate(time) {
      if(time){
        let date=new Date(time)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? '0' + m : m
        let d = date.getDate()
        d = d < 10 ? '0' + d : d
        return  m + '/' + d
      }else{
        return ''
      }
    } ,
    toggleCheckbox(row,checkboxProp,weekDay){
      console.log(row)
      if (row[checkboxProp] !== undefined) {
        row[checkboxProp] = !row[checkboxProp];
      }
      let obj={
        weekNum:this.weekObj.weekNum,
        startTime:this.zeroFill(row.period.ptStr),
        endTime:this.zeroFill(row.period.ptEnd),
        ptName:row.period.ptName,
        weekDay:weekDay,
        weekDayTime:weekDay=='1'?this.weekDayList[0]+'':this.weekDayList[weekDay-1]+''
      }
      if(row[checkboxProp]){
        this.timeTableData.push(obj)
      }else{
        const indexToRemove = this.timeTableData.findIndex(item =>
          item.weekNum === obj.weekNum &&
          item.starTime === obj.starTime &&
          item.endTime === obj.endTime &&
          item.ptName === obj.ptName &&
          item.weekDay === obj.weekDay
        );

        if (indexToRemove !== -1) {
          this.timeTableData.splice(indexToRemove, 1);
        }
      }
      console.log(this.timeTableData,'timeTableData')
    },
    zeroFill(data){
      let arr = data.split(':')
      if(arr[0].length==1){
        arr[0]='0'+arr[0]
      }
      return arr.join(':')
    },
    changeWeek(val){
      if(val=='1'){
        if(this.weekObj.weekNum > 1) this.weekObj.weekNum--
      }else{
        this.weekObj.weekNum++
      }
      this.getLabScheduleList(this.weekObj)
      this.getWeekDayList(this.weekObj)
    },
    formatTimetableForm(data){
      let form = new FormData()
      form.append('year',data.year)
      form.append('term',data.term)
      form.append('weekNum',data.weekNum)
      form.append('labId',this.labId)
      return form
    },
    async getLabScheduleList(data, fn){
      let form = this.formatTimetableForm(data)
      const result = await axios.post('/LabUseController/getLabUseInfo',form)
      this.tableData = this.upDataKeys(result.data);
      if(fn) fn()
    },
    getWeekNum(){
      axios.post('/baseinfo/getSystemInfo').then(res=>{
        console.log(res,'周次学年')
        if(res.status=='200'){
          this.currentWeekNum = res.data.weekNum ? Number(res.data.weekNum) : 0
          this.weekObj = res.data
          this.getLabScheduleList(res.data)
          this.getWeekDayList(res.data)
        }
      })
    },
    getWeekDayList(data){
      let fds = new FormData()
      fds.append('year',data.year)
      fds.append('term',data.term)
      fds.append('weekNum',data.weekNum)
      axios.post('/LabUseController/getWeekDay',fds).then(res=>{
        console.log(res,'周次天数')
        this.weekDayList=res.data
      })
    },
    // 比较时间
    isOverTime(ptStr, currentTime){
      const timeList = ptStr.split(':');
      const now = new Date();
      let hours = isNaN(Number(timeList[0])) ? 0 : Number(timeList[0]); // 小时
      let minutes = isNaN(Number(timeList[1])) ? 0 : Number(timeList[0]) // 分钟
      let targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0).getTime();
      if(targetTime > currentTime){
        return false
      } else {
        return true
      }
    },
    // 判断是否超期 - 今天不可以预约，明天开始都可以
    isOverDay(row, columnName){
    //  console.log(columnName, 'startTime',row.period.ptStr, 'endTime', row.period.ptEnd)
      let flag = false
      const weekNum = this.weekObj.weekNum ? Number(this.weekObj.weekNum) : 0
      const currentTime = new Date().getTime();
      // 当前周等于选中的周
      if(this.currentWeekNum === weekNum) {
        // 如果是今天，不允许预约
        if(this.currentWeek === weeksMap[columnName]) {
          return true;
        }
        // 如枟当前的日期和选中日期是同一天 并且当前时间超过课程的时间段
        if(this.currentWeek === weeksMap[columnName] && this.isOverTime(row.period.ptStr, currentTime)) {
          return flag = true;
        }
        switch (columnName) {
          case '周一':
            // 用户选择周一 如果当天是周一之后的日期，则周一下的复选框不能显示
            if((this.currentWeek === 2 || this.currentWeek === 3 || this.currentWeek === 4 || this.currentWeek === 5 || this.currentWeek === 6 || this.currentWeek === 0)){
              flag = true;
            }
            break;
          case '周二':
            if((this.currentWeek === 3 || this.currentWeek === 4 || this.currentWeek === 5 || this.currentWeek === 6 || this.currentWeek === 0)){
              flag = true;
            }
            break;
          case '周三':
            if((this.currentWeek === 4 || this.currentWeek === 5 || this.currentWeek === 6 || this.currentWeek === 0)){
              flag = true;
            }
            break;
          case '周四':
            if((this.currentWeek === 5 || this.currentWeek === 6 || this.currentWeek === 0)){
              flag = true;
            }
            break;
          case '周五':
            if((this.currentWeek === 6 || this.currentWeek === 0)){
              flag = true;
            }
            break;
          case '周六':
            if((this.currentWeek === 0)){
              flag = true;
            }
            break;
          case '周日':
            flag = false
            break;
          default:
            // 如果点击的是非星期列，则不做任何操作
            flag = true;
        }
      } else if(this.currentWeekNum < weekNum){
        flag = false
      } else {
        flag = true
      }
    //  console.log('flag', flag)
      return flag;
    },
    columnClick(row, column, _cell, _event,){
      const columnName = column.label;
      if(this.isOverDay(row, columnName)) return
      // 根据列名更新对应的复选框状态
      switch (columnName) {
        case '周一':
          this.toggleCheckbox(row, 'mondaycheck','1');
          break;
        case '周二':
          this.toggleCheckbox(row, 'tuesdaycheck','2');
          break;
        case '周三':
          this.toggleCheckbox(row, 'wednesdaycheck','3');
          break;
        case '周四':
          this.toggleCheckbox(row, 'thursdaycheck','4');
          break;
        case '周五':
          this.toggleCheckbox(row, 'fridaycheck','5');
          break;
        case '周六':
          this.toggleCheckbox(row, 'saturdaycheck','6');
          break;
        case '周日':
          this.toggleCheckbox(row, 'sundaycheck','7');
          break;
        default:
          // 如果点击的是非星期列，则不做任何操作
          return;
      }
    },
    columnStyle({ row, _column, _rowIndex, columnIndex }) {
      if (columnIndex == 1) {
        if (row.monday && row.monday[0]) {
          return 'background:#F6F8FB;color:#8A9491;text-align:center'
        }
        if(row.mondaycheck){
          return 'background: #d0dbeb;'
        }
      } else if (columnIndex == 2) {
        if (row.tuesday && row.tuesday[0]) {
          return 'background:#F6F8FB;color:#8A9491;text-align:center'
        }
        if(row.tuesdaycheck){
          return 'background: #d0dbeb;'
        }
      }else if(columnIndex == 3){
        if (row.wednesday && row.wednesday[0]) {
          return 'background:#F6F8FB;color:#8A9491;text-align:center'
        }
        if(row.wednesdaycheck){
          return 'background: #d0dbeb;'
        }
      }else if(columnIndex == 4){
        if (row.thursday && row.thursday[0]) {
          return 'background:#F6F8FB;color:#8A9491;text-align:center'
        }
        if(row.thursdaycheck){
          return 'background: #d0dbeb;'
        }
      }else if(columnIndex == 5){
        if (row.friday && row.friday[0]) {
          return 'background:#F6F8FB;color:#8A9491;text-align:center'
        }
        if(row.fridaycheck){
          return 'background: #d0dbeb;'
        }
      }else if(columnIndex == 6){
        if (row.saturday && row.saturday[0]) {
          return 'background:#F6F8FB;color:#8A9491;text-align:center'
        }
        if(row.saturdaycheck){
          return 'background:#d0dbeb'
        }
      }else if(columnIndex == 7){
        if (row.sunday && row.sunday[0]) {
          return 'background:#F6F8FB;color:#8A9491;text-align:center'
        }
        if(row.sundaycheck){
          return 'background: #d0dbeb;'
        }
      }
    },
    upDataKeys(data){
      const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
      return data.map(item => {
        let newItem = {};
        for (let i = 1; i <= 7; i++) {
          if (item[i] !== undefined) {
            newItem[daysOfWeek[i - 1]] = item[i];
          }
        }
        newItem.mondaycheck=false
        newItem.tuesdaycheck=false
        newItem.wednesdaycheck=false
        newItem.thursdaycheck=false
        newItem.fridaycheck=false
        newItem.saturdaycheck=false
        newItem.sundaycheck=false
        newItem.period = { ...item.period };
        return newItem;
      });
    },
    getProjectList(){
      axios.get('/dict/getDictListById?id=0214').then(res=>{
        if(res.status=='200'){
          console.log(res,'res')
          this.projectList=res.data
          this.projectList = this.projectList.map((item) => ({
            text: item.dictName,
            id: item.dictNo,
          }));
        }
      })
    },
    onConfirm(value){
      this.labType = value.id;
      this.project=value.text
      this.showPicker = false;
    },
    async submit(){
      try {
        await this.$refs.formRef.validate()
        // if(this.applyUserId==''){
        //   this.$toast('请填写校园卡号！')
        //   return
        // }
        let fd=new FormData()
        let applyDateJson={}
        let labList=[{labName:this.labName,id:this.labId}]
        if(this.timeTableData&&this.timeTableData.length>0){
          applyDateJson.openApplyPeriods=this.timeTableData
          applyDateJson.labType=this.labType
          applyDateJson.labList=labList
          applyDateJson.groupNum = this.groupNum
          applyDateJson.isGroupUser='1'
          applyDateJson.phone = this.phone
          applyDateJson=JSON.stringify(applyDateJson)
          // fd.append('applyUserId',this.applyUserId)
          fd.append('applyDateJson',applyDateJson)
          axios.post('/labOpen/saveMWOpenApplyList',fd).then(res=>{
            if(res.data.code=='2'){
              this.$toast('提交成功！')
              this.getLabScheduleList(this.weekObj, () => {
                this.$router.push({
                  path: '/myApply',
                });
            })
            }else{
              this.$toast(res.data.msg)
            }
          })
        }else{
          this.$toast('请选择预约时间！')
        }
      }catch(error) {
        console.log(error)
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  mounted() {
    this.labName = this.$route.query.labName
    this.labId = this.$route.query.labId
    this.getProjectList()
    this.getWeekNum()
  }
}
</script>


<style scoped lang="less">
.cell-number-style {
  width: 100%;text-align: center; display: flex; flex-direction: column; align-items: center;
}
.cell-pic {
  width:16px;
  height:17px;
  min-width: 10px;
  min-height: 11px;
  background: url("../../assets/apply/yuuser.png") no-repeat center
}
.form-cotain {
  margin: 10px;
  border-radius: 10px;
}
.reservationBox{
  background-color: #F4F6FA;
  padding-top: 5px;
  height:100%;
}
.overTimeBtn {
  position:absolute; top:0; left:0; right:0;bottom:0; background-color: #F6F8FB;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.nav-item{
  width: 50%;
}
.nav-item {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 60px; /* 调整按钮和文本的高度 */
  margin: auto; /* 居中对齐 */
}

.nav-button {
  width: 30px;
  height: 30px;
  font-size:16px;
  border: 1px solid #E5E5E5;
  background-color: #F6F8FB;
  cursor: pointer;
  color: #333;
}

.nav-text {
  font-size: 18px;
  color: #333;
  padding: 0 10px; /* 添加一些内边距 */
}
::v-deep .van-form > .van-cell:first-child {
  border-radius: 5px 5px 0 0;
}
::v-deep .van-form > .van-cell:last-child {
  border-radius: 0 0 5px 5px;
}
 ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #13499b; /* 选中时背景颜色 */
  border-color: #13499b;     /* 选中时边框颜色 */
}
::v-deep .el-checkbox__inner {
  width: 22px;           /* 调整宽度 */
  height: 22px;          /* 调整高度 */
  border-radius: 50%;    /* 圆角 */
  background-color: #fff;
}

/* 确保勾选标记也适应新的尺寸 */
::v-deep .el-checkbox__inner::after {
  left: 7px;             /* 调整位置 */
  top: 2px;
  width: 4px;            /* 调整宽度 */
  height: 10px;          /* 调整高度 */
  border-width: 2px;     /* 调整线条粗细 */
  transform: rotate(45deg) scaleY(1); /* 确保对号显示正常 */
}
.bottom_box{
  width: 100%;
  z-index: 1000;
  height: 80px;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  padding: 0 15px;
  line-height: 80px;
  .el-button{
    width: 100%;
    background-color: #13499b;
    color: #FFFFFF;
    border: none;
  }
}
.schedule-table{
  position: absolute;
  top:245px;
  bottom:85px;
  right:10px;
  left:10px;
  border-radius:10px 10px 0 0;
  background-color: #ffffff;
  overflow-y: auto;
}

</style>
